import { useCallback } from "react";
import { getPointedDeviceId } from "../../reducers/devices";
import { postNextItem } from "../../controllers/SpotifyApiController";
import { useDispatch, useSelector } from "react-redux";
import { getRandomModeActive } from "../../reducers/randomMode";
import { updatePlaybackState } from "../../actions/playbackStateActions";
import { setPlaybackAction } from "../../actions/disablingProcessesActions";
import { manageTooManyRequestsResponse } from "../../utils/connectionUtils";

export const useNextSong = () => {
    const randomModeActive = useSelector(getRandomModeActive);
    const pointedDeviceId = useSelector(getPointedDeviceId);
    const dispatch = useDispatch();

    return useCallback(() => {
        dispatch(setPlaybackAction(true));

        if(randomModeActive)
        {
            dispatch(updatePlaybackState());
        }

        postNextItem(pointedDeviceId)  
            .then(() => {
                dispatch(setPlaybackAction(false));
            })
            .catch((error) => {
                dispatch(setPlaybackAction(false));
                manageTooManyRequestsResponse(error, dispatch);
                console.error('Error skipping to previous item: ', error);
            })
    }, [pointedDeviceId, randomModeActive, dispatch]);
}